import NotAuthorized from "pages/NotAuthorized";
import React from "react";
import { useSessionStore } from "stores/userSessionStore";

// Define the props for the PrintLayout component
// This interface defines the structure of the props that the PrintLayout component will receive
interface PrintLayoutProps {
  children: React.ReactNode;
}

// PublicLayout component
// This component is used to render content for public pages, such as the home page or about page.
// It includes a header and a main section where the children components will be rendered.
const PrintLayout = ({ children }: PrintLayoutProps) => {
  const { isLoggedIn } = useSessionStore();
  if (!isLoggedIn) return <NotAuthorized />;

  return <div>{children}</div>;
};

export default PrintLayout;
